// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueRouter from 'vue-router'
import 'babel-polyfill' // 兼容ie9
import 'amfe-flexible' // 用于rem的适配
import './rem.js'
import { post, fetch, patch, put, postForm } from './utils/api'
import { handleCofirm, handleAlert, handleMessage } from './child/avplan/commonjs/confirmMessage'
import { freshMenu } from './child/avplan/commonjs/freshMenu'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueMoment from 'vue-moment'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/assets/icon/iconfont.css'
import '@/assets/icon/iconfont.js'
import '@/assets/icon/icon.css'
import preventReClick from './utils/preventReClick' //防多次点击，重复提交
import dataV from '@jiaminghi/data-view'
import draggable from 'vuedraggable'
import global from './Global'
import Vue2Storage from 'vue2-storage'
import echarts from 'echarts'
import { btPrint_onclick, btPreview_onclick } from './utils/printWord/js/PrintHelp'
import VueDOMPurifyHTML from 'vue-dompurify-html'


// require('./utils/mock') // 增加mock模块，假数据使用,测试真实后台，将此注释掉

Vue.use(Vant) // Vant 是有赞开源的一套基于 Vue 2.0 的 Mobile 组件库https://youzan.github.io/vant
Vue.use(Antd) // 增加antdesign能力 https://mobile.ant.design/docs/react/introduce-cn
Vue.use(ElementUI) // 增加elementUI能力 https://element.faas.ele.me
Vue.use(VueMoment) // 时间计算相关Util 使用moment
Vue.use(preventReClick) //防止重复点击
Vue.use(dataV)
Vue.use(draggable)
Vue.use(Vue2Storage) // 缓存插件
Vue.use(VueDOMPurifyHTML)

// 定义全局变量
Vue.prototype.$post = post
Vue.prototype.$fetch = fetch
Vue.prototype.$patch = patch
Vue.prototype.$put = put
Vue.prototype.$postForm = postForm
Vue.prototype.$echarts = echarts

Vue.prototype.$confirmInfo = handleCofirm
Vue.prototype.$alertInfo = handleAlert
Vue.prototype.$messageInfo = handleMessage

Vue.prototype.$global = global

Vue.prototype.$freshMenu = freshMenu
//新模板使用时间
Vue.prototype.$BASETIMELINE = '2022-02-27'

Vue.prototype.$GIFPATH = 'http://10.1.50.234:8080'
Vue.config.productionTip = false

Vue.prototype.$btPrint_onclick = btPrint_onclick
Vue.prototype.$btPreview_onclick = btPreview_onclick

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {

  if (to.meta.requireAuth) { // 判断跳转的路由是否需要登录
    if (localStorage.getItem('isLogin') === '0') { // vuex.state判断token是否存在
      next() // 已登录
    } else {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    //判断是否刷新页面且不是登录页面 刷新则重载菜单
    if (to.path.indexOf('/login') !== -1) {
      next()
    } else {
      const token = localStorage.getItem('token')
      //无token
      if (token === undefined || token === null || token === '') {
        next('/login')
      } else {
        if ((to.path === '/avplanPmp' !== -1 || to.path.indexOf('avplanPmp/index') !== -1) &&
          (store.state.menuState.menu.length === (localStorage.getItem('menu') === null ? 0 : JSON.parse(localStorage.getItem('menu')).length))
        ) {
          next()
        } else if (store.state.menuState.menu.length !== (localStorage.getItem('menu') === null ? 0 : JSON.parse(localStorage.getItem('menu')).length)) {
          store.commit('addMenu')
          store.commit('add_homeTag')
          next({ path: to.path })
        }
      }
    }

  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data: {
    rawHtml: '<script>alert("XSS")</script><p>Some safe content</p>'
  },
  render: h => h(App)
})
